import { _values, tsValidate_OptionalArray, tsValidateArray, tsValidateBoolean, tsValidateDynamicObject, tsValidateEnum, tsValidateExists, tsValidateMustExist, tsValidateNumber, tsValidateOptionalId, tsValidateOptionalObject, tsValidateResult, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { CareMap_RuleStatus, CareMapCriticality, CareMapLLMStatus, CareMapPlacementReason, ConsiderationGroupEnum, PathwayStatus, ProtocolListAssignment, RequiredSnippetStatus } from './types.js';
import { AdvisorRuntimeIDBGroup, Validator_EncounterId } from '../_core/index.js';
const Validator_NeededVariables = (instance) => {
    if (!instance)
        return 'No instance provided for validation';
    return tsValidateResult(instance, {
        variableId: tsValidateUniqueId,
        findingId: tsValidateOptionalId,
        innerVariables: tsValidate_OptionalArray(Validator_NeededVariables),
        attributes: tsValidate_OptionalArray(Validator_NeededVariables),
        children: tsValidate_OptionalArray(Validator_NeededVariables),
        scoresByDisease: tsValidateExists(false),
        totalScore: tsValidateNumber(false)
    });
};
const Validator_CareMapRuling = {
    careMapRule: tsValidateEnum(CareMap_RuleStatus, false),
    latestCareMapRuleTimestamp: tsValidateNumber(false),
};
const Validator_CareMapOutcome = {
    considerationGroup: tsValidateValue(_values(ConsiderationGroupEnum), false),
    criticality: tsValidateValue([...CareMapCriticality]),
    score: tsValidateNumber(),
    normalizedScore: tsValidateNumber(),
    diseaseScoresByFindingDpvs: tsValidateArray(tsValidateMustExist),
    lowConsiderationPercRecall: tsValidateNumber(),
    highConsiderationPercRecall: tsValidateNumber(),
    lowConsiderationValue: tsValidateNumber(),
    highConsiderationValue: tsValidateNumber(),
    dpvsFindingsMap: tsValidateArray(tsValidateMustExist),
    sortingIndex: tsValidateNumber(),
    // EM-produced verdict + LLM debug fields are optional on the wire. The
    // first-class verdict (placementReason / llmStatus) is value-validated; the
    // nested rule/LLM response objects are read-only debug payloads accepted as-is
    // (optional, shape not re-validated here).
    placementReason: tsValidateValue(_values(CareMapPlacementReason), false),
    llmStatus: tsValidateValue(_values(CareMapLLMStatus), false),
    ruleResponse: tsValidateExists(false),
    llmValidatorResponse: tsValidateExists(false),
};
const Validator_ModifiableProps = {
    ...Validator_EncounterId,
    pathwayId: tsValidateUniqueId,
    variableIds: tsValidateArray(tsValidateUniqueId),
    neededVariables: tsValidateArray(Validator_NeededVariables),
    requiredWizards: tsValidateArray({
        wizardId: tsValidateUniqueId,
        status: tsValidateValue(_values(RequiredSnippetStatus))
    }),
    orders: tsValidateArray(tsValidateMustExist),
    activeConsiderationGroup: {
        considerationGroup: tsValidateValue(_values(ConsiderationGroupEnum)),
        setManually: tsValidateBoolean()
    },
    status: tsValidateValue(_values(PathwayStatus), false),
    listAssignment: tsValidateValue(_values(ProtocolListAssignment), false),
    minConfidenceBar: tsValidateNumber(false),
    careMapOutcomes: tsValidateDynamicObject(Validator_CareMapOutcome, tsValidateUniqueId, false),
    careMapRuling: tsValidateOptionalObject(Validator_CareMapRuling),
};
const Validator_GeneratedProps = {};
export const DBDef_RuntimeProtocol = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'runtime-protocols',
    entityName: 'RuntimeProtocol',
    frontend: {
        group: AdvisorRuntimeIDBGroup,
        name: 'runtime-protocols'
    },
    backend: {
        name: 'runtime-protocols'
    }
};
//# sourceMappingURL=db-def.js.map